const types = {
	affiliate_question: 'affiliate_question',
	offer_access: 'offer_access',
	admin_ticket: 'admin_ticket',
	new_landing_transit: 'new_landing_transit',
	improve_translation: 'improve_translation',
	promo_code_activation: 'promo_code_activation',
	admin_notification: 'admin_notification',
	deactivated_login_try: 'deactivated_login_try',
	blacklisted_ip_login_try: 'blacklisted_ip_login_try',
	gift_order: 'gift_order',
	bm_account_order: 'bm_account_order',
	invalid_domain: 'invalid_domain',
	affiliate_appeal: 'affiliate_appeal'
};

const locale = {
	ru: {
		affiliate_question: 'вопросы вебов',
		offer_access: 'доступ к офферу',
		admin_ticket: 'тикет от администрации',
		new_landing_transit: 'добавление лендингов/транзитов',
		improve_translation: 'уточнение перевода',
		promo_code_activation: 'активация промокода',
		admin_notification: 'уведомление администратора',
		deactivated_login_try: 'попытка логина деактивированого веба',
		blacklisted_ip_login_try: 'попытка логина c запрещенного ip',
		gift_order: 'заказ подарка',
		bm_account_order: 'заказ BM аккаунта',
		invalid_domain: 'некорректный домен лендинга / транзитной страницы',
		affiliate_appeal: 'апелляция веба'
	},
	en: {
		affiliate_question: `affiliates' questions`,
		offer_access: 'offer access',
		admin_ticket: 'admin ticket',
		new_landing_transit: 'new landings/transits',
		improve_translation: 'improve translation',
		promo_code_activation: 'promo code activation',
		admin_notification: 'admin notification',
		gift_order: 'gift order',
		deactivated_login_try: 'deactivated login try',
		blacklisted_ip_login_try: 'blacklisted ip login try',
		bm_account_order: 'bm account order',
		invalid_domain: 'invalid domain of landing / transit page',
		affiliate_appeal: 'affiliate appeal'
	},
	uk: {
		affiliate_question: `affiliates' questions`,
		offer_access: 'offer access',
		admin_ticket: 'admin ticket',
		new_landing_transit: 'new landings/transits',
		improve_translation: 'improve translation',
		promo_code_activation: 'promo code activation',
		admin_notification: 'admin notification',
		gift_order: 'gift order',
		deactivated_login_try: 'deactivated login try',
		blacklisted_ip_login_try: 'blacklisted ip login try',
		bm_account_order: 'bm account order',
		invalid_domain: 'invalid domain of landing / transit page',
		affiliate_appeal: 'affiliate appeal'
	},
	de: {
		affiliate_question: `affiliates' questions`,
		offer_access: 'offer access',
		admin_ticket: 'admin ticket',
		new_landing_transit: 'new landings/transits',
		improve_translation: 'Übersetzung verbessern',
		promo_code_activation: 'promo code activation',
		admin_notification: 'admin notification',
		gift_order: 'gift order',
		bm_account_order: 'bm account order',
		deactivated_login_try: 'deactivated login try',
		blacklisted_ip_login_try: 'blacklisted ip login try',
		invalid_domain: 'invalid domain of landing / transit page',
		affiliate_appeal: 'affiliate appeal'
	},
	vi: {
		affiliate_question: `affiliates' questions`,
		offer_access: 'offer access',
		admin_ticket: 'admin ticket',
		new_landing_transit: 'new landings/transits',
		improve_translation: 'improve translation',
		promo_code_activation: 'promo code activation',
		admin_notification: 'admin notification',
		gift_order: 'gift order',
		bm_account_order: 'bm account order',
		deactivated_login_try: 'deactivated login try',
		blacklisted_ip_login_try: 'blacklisted ip login try',
		invalid_domain: 'invalid domain of landing / transit page',
		affiliate_appeal: 'affiliate appeal'
	},
	th: {
		affiliate_question: `คำถามของเวบ`,
		offer_access: 'การเข้าถึงข้อเสนอต่างๆ',
		admin_ticket: 'หมายเลขจากคณะผู้จัดทำ',
		new_landing_transit: 'การเพิ่มร้านค้าออนไลน์ การส่งผ่านข้อมูล',
		improve_translation: 'ปรับปรุงการแปล',
		promo_code_activation: 'promo code activation',
		admin_notification: 'admin notification',
		gift_order: 'gift order',
		bm_account_order: 'bm account order',
		deactivated_login_try: 'deactivated login try',
		blacklisted_ip_login_try: 'blacklisted ip login try',
		invalid_domain: 'invalid domain of landing / transit page',
		affiliate_appeal: 'affiliate appeal'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/thread-categories.js